export const GET_IS_SEARCH_DISABLED = "GET_IS_SEARCH_DISABLED";
export const GET_PREVIOUS_SEARCH_TEXT = "GET_PREVIOUS_SEARCH_TEXT";
export const GET_SEARCH_TEXT = "GET_SEARCH_TEXT";
export const SET_IS_SEARCH_DISABLED = "SET_IS_SEARCH_DISABLED";
export const SET_PREVIOUS_SEARCH_TEXT = "SET_PREVIOUS_SEARCH_TEXT";
export const SET_SEARCH_TEXT = "SET_SEARCH_TEXT";
